export const imgPath = 'https://b2b.traveldesk.me/img'
export const b2bPath = 'https://b2b.traveldesk.me/'
